import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ship2',
  templateUrl: './ship2.component.html',
  styleUrls: ['./ship2.component.css']
})
export class Ship2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
